// A2-535 (found 2026-10-25 by the Antigravity UX review, U1): the GB form said
// "All reconciliations passed. Ready to file." while the calculation's own
// check for GB had failed (R4, a 42,889.96 difference) and Step 4 said DO NOT
// FILE. The server now holds "ready to file" for such a return and sends the
// failures (api/_recon_gate.apply_calc_check_blocker); this says so on the form
// — or, once the operator overrode them at sign-off, says THAT, with the reason.
import React from "react";
import { useTranslation } from "react-i18next";

const money = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : String(v ?? "");
};

export const CalcCheckBlocker = ({ data }) => {
  const { t } = useTranslation();
  if (!data || !(data.failures || []).length) return null;
  const overridden = !!data.override;
  return (
    <div data-testid="calc-check-blocker" data-overridden={overridden ? "true" : "false"}
      className={`text-sm rounded-lg p-3 mb-4 border ${overridden
        ? "text-amber-900 dark:text-amber-100 bg-amber-50 dark:bg-amber-950/40 border-amber-400 dark:border-amber-700"
        : "text-red-900 dark:text-red-100 bg-red-50 dark:bg-red-950/40 border-red-500 dark:border-red-700"}`}>
      <div className="font-bold">
        {overridden
          ? t("ui.country_return.calc_check.overridden_title", { defaultValue: "Signed off over a failed check of this calculation" })
          : t("ui.country_return.calc_check.title", { defaultValue: "Do not file: this calculation's own check failed for this return" })}
      </div>
      <ul className="mt-1 space-y-0.5 text-xs tabular-nums">
        {data.failures.map((f, i) => (
          <li key={i}>
            {f.label}: {t("ui.country_return.calc_check.diff", {
              expected: money(f.expected), actual: money(f.actual), delta: money(f.delta),
              defaultValue: `expected ${money(f.expected)}, got ${money(f.actual)} (difference ${money(f.delta)})`,
            })}
          </li>
        ))}
      </ul>
      <div className="mt-1 text-xs">
        {overridden
          ? t("ui.country_return.calc_check.overridden_reason", { reason: data.override.reason, defaultValue: `Reason recorded at sign-off: "${data.override.reason}"` })
          : t("ui.country_return.calc_check.what", { defaultValue: "The figures do not add up, so the boxes below may be wrong. Step 4 shows the check; correct the rows it names and re-run the calculation." })}
      </div>
    </div>
  );
};

export default CalcCheckBlocker;
